import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import { FaWarehouse } from "react-icons/fa6";
import '../../css/custom-scrollbar.css';
import { Base_Url, getpincode } from '../../../config/config'
import { toast } from 'react-toastify';

import {
    FaIdCard,
    FaAddressCard,
    FaMapMarkerAlt,
    FaUndo,
    FaTimes,
    FaEdit,
    FaSave,
} from 'react-icons/fa';


const schema = z.object({ 
    // orderId: z.string()
    //   .min(1, "Order ID is required")
    //   .regex(/^\d+$/, "Order ID must be numeric"),
    Name: z.string()
        .min(1, "Name is required")
        .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabetic characters"),

    email: z.string()
        .email("Invalid email address"),
    phone: z.string()
        .length(10, "Phone number must be exactly 10 digits")
        .regex(/^\d+$/, "Phone number must be numeric"),
    contact_person: z.string()
        .min(1, "contact_person is required")
        .regex(/^[a-zA-Z\s]+$/, "contact_person must only contain alphabetic characters"),
    // status: z.string().min(1, "Status is required"),
    date: z.string().min(1, "Add Date is required"),
    address: z.string().min(1, "Address is required"),
    pincode: z.string()
        .length(6, "Pincode must be exactly 6 characters")
        .regex(/^\d+$/, "Pincode must be numeric"),
    city: z.string()
        .min(1, "City is required")
        .regex(/^[A-Za-z\s]+$/, "City must only contain letters and spaces"),
    state: z.string()
        .min(1, "State is required")
        .regex(/^[A-Za-z\s]+$/, "State must only contain letters and spaces"),
    country: z.string()
        .min(1, "Country is required")
        .regex(/^[A-Za-z\s]+$/, "Country must only contain letters and spaces"),
    registerName: z.string()
        .min(1, "Register Name is required")
        .regex(/^[a-zA-Z\s]+$/, "Register Name must only contain alphabetic characters"),
    returnAddress: z.string().optional(),
});


const B2bViewWarehouse = ({ isopen, onClose, warehouse }) => {
    // const token = localStorage.getItem('token');
    // const cusid = localStorage.getItem('cus_id');
    const { isDarkMode } = useMyContext();
    const [isEditMode, setIsEditMode] = useState(false);
    const [isEditId, isSetEditId] = useState(true);
    const [isEditEmail, isSetEditEmail] = useState(true);
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm({
        resolver: zodResolver(schema),
    });

    useEffect(() => {
  if (warehouse) {
    reset({
      Id: warehouse.id || '',
      Name: warehouse.name || '',
      email: warehouse.email || '', 
      phone: warehouse.phone_number || '', 
      contact_person: warehouse.contact_person || '',
      date: warehouse.created_at || '', 
      address: warehouse.address || '',
      pincode: warehouse.pin_code || '', 
      city: warehouse.city || '',
      state: warehouse.state || '',
      country: warehouse.country || '',
      registerName: warehouse.name || '',
      returnAddress: warehouse.ret_address || '', 
    });
  } 
}, [warehouse, reset]);

    const onErrors = (errors) => {
        toast.error("Please fix the errors in the form.");
    };

    const handleClose = () => {
        setIsEditMode(false);
        onClose();
    };

    const hanldeAllEditFileds = () => {
        setIsEditMode(!isEditMode);
    }

    const fetchPincodeData = async (pincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            }); 
            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];

                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
                setValue("city", city);
                setValue("state", state);
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                // toast.error(data.message + " Please login Again");
            }
            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const fetchreturnPincodeData = async (returnPincode) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
        try {
            const response = await fetch(urlgetPincode, {
                method: 'GET',
                headers: {
                    'token': token,
                    'cus_id': cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data && data.status === "SUCCESS") {
                let { city, state } = data.data[0];

                city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
                state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

                setValue("returnCity", city);
                setValue("returnState", state);
            }
            else if (data && data.message === "Unauthorized access - Invalid token") {
                // toast.error(data.message + " Please login Again");
            }

            else if (data && data.status === "FAIL") {
                toast.error("Something Went Wrong Please Try Again With Another Pincode");
            }
            else {
                toast.error("Failed to fetch city and state data");
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);
            toast.error("Error fetching pincode data");
        }
    };

    const handleInputChange = (event) => {
        const { value, id } = event.target;
        if (['pincode', 'phone', 'return-pincode'].includes(id)) {
            const filteredValue = value.replace(/[^0-9]/g, '');
            event.target.value = filteredValue;
            // Trigger API call if input reaches 6 digits for `return-pincode`
            if (id === 'return-pincode' && filteredValue.length === 6) {
                fetchreturnPincodeData(filteredValue);
            }
            if (id === 'pincode' && filteredValue.length === 6) {
                fetchPincodeData(filteredValue);
            }
        }
        if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
            event.target.value = filteredValue;

        }
    };

    // ── Compact style helpers ──
    const sectionWrap = (borderColor) =>
        `p-1 rounded-lg border-l-2 ${borderColor} ${isDarkMode ? 'bg-white/5' : 'bg-gray-50'}`;

    const cardWrap = `p-1 rounded-md ${isDarkMode ? 'bg-darkmodeColor' : ''}  ${isDarkMode ? '' : ''}`;

    const labelClass = `block text-[10px] font-semibold uppercase tracking-wide mb-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`;

    const inputClass = (hasError) =>
        `w-full px-2.5 py-1 text-xs border rounded-md transition-all focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-70
        ${hasError ? 'border-red-400' : isDarkMode ? 'border-white/15 bg-transparent text-white' : 'border-gray-200 bg-gray-50 text-gray-800'}`;

    return (
        <Dialog
            open={isopen}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                className: "rounded-xl overflow-hidden"
            }}
        >
            <DialogTitle className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white relative !py-2.5 !px-4">
                <h2 className="text-xs font-bold text-white font-sans flex items-center">
                    <FaWarehouse className="mr-2" size={14} />
                    Warehouse Details
                </h2>
                <IoIosCloseCircle
                    className="absolute top-2.5 right-3 cursor-pointer hover:scale-110 transition-transform"
                    size={18}
                    onClick={handleClose}
                />
            </DialogTitle>

            <DialogContent className="bg-white dark:bg-darkmodeColor dark:text-white custom-scrollbar !p-0" style={{ maxHeight: '75vh' }}>
                <div className="p-3.5 bg-white dark:bg-darkmodeColor dark:text-white">
                    <form className="space-y-3 font-sans">

                        {/* Primary Information Section */}
                        <div className={sectionWrap('border-purple-500')}>
                            <h3 className="text-[11px] font-bold mb-2 text-purple-600 dark:text-purple-300 flex items-center uppercase tracking-wide">
                                <FaIdCard className="mr-1.5" size={11} />
                                Primary Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div className={cardWrap}>
                                    <label className={labelClass}>ID</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.Id)}
                                        {...register('Id')}
                                        disabled={isEditId}
                                    />
                                    {errors.Id && <p className="text-red-500 text-[10px] mt-1">{errors.Id.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Name</label>
                                    <input
                                        type="text"
                                        id="facility-name"
                                        className={inputClass(errors.Name)}
                                        {...register('Name')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.Name && <p className="text-red-500 text-[10px] mt-1">{errors.Name.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Contact Information Section */}
                        <div className={sectionWrap('border-blue-500')}>
                            <h3 className="text-[11px] font-bold mb-2 text-blue-600 dark:text-blue-300 flex items-center uppercase tracking-wide">
                                <FaAddressCard className="mr-1.5" size={11} />
                                Contact Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Email</label>
                                    <input
                                        type="email"
                                        className={inputClass(errors.email)}
                                        {...register('email')}
                                        disabled={isEditEmail}
                                    />
                                    {errors.email && <p className="text-red-500 text-[10px] mt-1">{errors.email.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Contact Person</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.contact_person)}
                                        {...register('contact_person')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.contact_person && <p className="text-red-500 text-[10px] mt-1">{errors.contact_person.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Phone</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        className={inputClass(errors.phone)}
                                        {...register('phone')}
                                        maxLength={10}
                                        disabled={!isEditMode}
                                    />
                                    {errors.phone && <p className="text-red-500 text-[10px] mt-1">{errors.phone.message}</p>}
                                </div>
                                <div className={cardWrap}>
                                    <label className={labelClass}>Add Date</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.date)}
                                        {...register('date')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.date && <p className="text-red-500 text-[10px] mt-1">{errors.date.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Address Information Section */}
                        <div className={sectionWrap('border-green-500')}>
                            <h3 className="text-[11px] font-bold mb-2 text-green-600 dark:text-green-300 flex items-center uppercase tracking-wide">
                                <FaMapMarkerAlt className="mr-1.5" size={11} />
                                Address Information
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Address</label>
                                    <input
                                        type="text"
                                        id="address"
                                        className={inputClass(errors.address)}
                                        {...register('address')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.address && <p className="text-red-500 text-[10px] mt-1">{errors.address.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Pincode</label>
                                    <input
                                        type="text"
                                        id="pincode"
                                        className={inputClass(errors.pincode)}
                                        {...register('pincode')}
                                        onChange={handleInputChange}
                                        maxLength={6}
                                        disabled={!isEditMode}
                                    />
                                    {errors.pincode && <p className="text-red-500 text-[10px] mt-1">{errors.pincode.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                                <div className={cardWrap}>
                                    <label className={labelClass}>City</label>
                                    <input
                                        type="text"
                                        id="city"
                                        className={inputClass(errors.city)}
                                        {...register('city')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.city && <p className="text-red-500 text-[10px] mt-1">{errors.city.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        className={inputClass(errors.state)}
                                        {...register('state')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.state && <p className="text-red-500 text-[10px] mt-1">{errors.state.message}</p>}
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
                                <div className={cardWrap}>
                                    <label className={labelClass}>Country</label>
                                    <input
                                        type="text"
                                        id='country'
                                        className={inputClass(errors.country)}
                                        {...register('country')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.country && <p className="text-red-500 text-[10px] mt-1">{errors.country.message}</p>}
                                </div>

                                <div className={cardWrap}>
                                    <label className={labelClass}>Register Name</label>
                                    <input
                                        type="text"
                                        className={inputClass(errors.registerName)}
                                        {...register('registerName')}
                                        disabled={!isEditMode}
                                    />
                                    {errors.registerName && <p className="text-red-500 text-[10px] mt-1">{errors.registerName.message}</p>}
                                </div>
                            </div>
                        </div>

                        {/* Return Address Section */}
                        <div className={sectionWrap('border-yellow-500')}>
                            <h3 className="text-[11px] font-bold mb-2 text-yellow-600 dark:text-yellow-300 flex items-center uppercase tracking-wide">
                                <FaUndo className="mr-1.5" size={11} />
                                Return Address Details
                            </h3>
                            <div className={cardWrap}>
                                <label className={labelClass}>Return Address</label>
                                <input
                                    type="text"
                                    id="returnAddress"
                                    className={inputClass(errors.returnAddress)}
                                    {...register('returnAddress')}
                                    disabled={!isEditMode}
                                />
                                {errors.returnAddress && <p className="text-red-500 text-[10px] mt-1">{errors.returnAddress.message}</p>}
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex gap-2 pt-1 pb-0.5">
                            <button
                                type="button"
                                onClick={hanldeAllEditFileds}
                                className="bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-2 px-4 rounded-md hover:from-purple-700 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 text-xs font-semibold transition-colors flex items-center shadow-sm"
                            >
                                {isEditMode ? (
                                    <>
                                        <FaTimes className="mr-1.5" size={11} /> Cancel Editing
                                    </>
                                ) : (
                                    <>
                                        <FaEdit className="mr-1.5" size={11} /> Edit Warehouse
                                    </>
                                )}
                            </button>

                            {(isEditMode && isEditId && isEditEmail) && (
                                <button
                                    type="submit"
                                    className="bg-gradient-to-r from-green-500 to-green-600 text-white py-2 px-4 rounded-md hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 text-xs font-semibold transition-colors flex items-center shadow-sm"
                                >
                                    <FaSave className="mr-1.5" size={11} /> Save Changes
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </DialogContent>
        </Dialog>
    );
};


export default B2bViewWarehouse;